module.exports = __webpack_public_path__ + "static/media/logo_standard_orange.5e51965b.png";